import { dew as _getObjectLikeUtilsDew } from "./getObjectLikeUtils";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.withParsedProperties = exports.getObjectLikeUtils = void 0;
  var getObjectLikeUtils_1 = _getObjectLikeUtilsDew();
  Object.defineProperty(exports, "getObjectLikeUtils", {
    enumerable: true,
    get: function () {
      return getObjectLikeUtils_1.getObjectLikeUtils;
    }
  });
  Object.defineProperty(exports, "withParsedProperties", {
    enumerable: true,
    get: function () {
      return getObjectLikeUtils_1.withParsedProperties;
    }
  });
  return exports;
}